import { Link } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';

// ===== 関連サイト / 日本執事アカデミー 全面刷新（新デザイン憲章適用・_shared廃止・inline化） =====
// 実文は working tree 現行実文を保持。外部公式URL butler-academy.jp は変更禁止。当ルートは pagesWithOwnFaq 登録済み＝FAQ自前描画。

const points = [
  { no: '01', title: '執事の育成', desc: 'エッセンシャルからマスターまで、体系立てたカリキュラムで執事を育成しています。', img: '/images/generated/jba-still-globe-01.webp', alt: '地球儀と羊の置物。学びの象徴' },
  { no: '02', title: '協会認定資格の発行', desc: '所定の課程を修了し実技試験に合格した方へ、協会認定のバトラー資格を授与し、育成した人材の質を保証しています。', img: '/images/generated/jba-fs-185-related_butler-academy.webp', alt: '協会認定資格の教材と資格発行の様子' },
  { no: '03', title: '実務を見据えた教育', desc: '英国式執事の規律と日本の礼節を土台に、実際のサービスの現場で活かせる所作と心構えを学びます。', img: '/images/generated/jba-fs-186-related_butler-academy-v6.webp', alt: '実務で活かせる所作と心構えを学ぶ様子' },
  { no: '04', title: '学びから実務への接続', desc: '修了生が執事サービス THE BUTLER などの現場で力を発揮し、学びと実務が一つの流れとしてつながっています。', img: '/images/generated/jba-fs-187-related_butler-academy-v7.webp', alt: '修了生がサービスの現場で力を発揮する様子' },
];

const faqs = [
  {
    q: '日本執事アカデミーとはどのような機関ですか？',
    a: '日本執事アカデミーは、一般社団法人全日本執事協会が運営する執事の教育・養成機関です。体系立てたカリキュラムで執事を育成し、所定の課程を修了し実技試験に合格した方へ協会認定資格を授与しています。',
  },
  {
    q: 'どのようなことを学べますか？',
    a: '英国式執事の規律と品格、日本ならではの細やかな礼節を土台に、テーブルサービスや立ち居振る舞い、来客対応など、実際のサービスの現場で活かせる所作と心構えを体系的に学びます。エッセンシャルからマスターまで段階的なカリキュラムを用意しています。',
  },
  {
    q: '協会や執事サービスとの関係は？',
    a: '日本執事アカデミーは当協会が運営する教育部門にあたります。アカデミーが育成した執事は、当協会が運営する執事サービス THE BUTLER などの現場で力を発揮しており、学びと実務が同じ協会のもとでつながっています。詳細は公式サイト butler-academy.jp をご覧ください。日本で唯一の学び舎を持つ執事養成学校である日本執事アカデミーならではの環境です。',
  },
];

const otherRelated = [
  { name: '全日本執事協会 THE BUTLER', role: '執事サービス', to: '/related/the-butler' },
  { name: '執事ベル', role: '情報発信ブランド', to: '/related/butler-bell' },
];

const breadcrumbs = [
  { label: 'ホーム', href: '/' },
  { label: '関連サイト', href: '/related' },
  { label: '日本執事アカデミー' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.08em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function RelatedButlerAcademyPage() {
  return (
    <Layout>
      {/* ===== ヒーロー ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-still-cabinet-02.webp" alt="書斎の飾り棚。学びの環境" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Japan Butler Academy</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.04em] mb-6">
              執事を育て、認める場所
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              一般社団法人全日本執事協会が運営する、執事の教育・養成機関です。日本の執事学校（執事養成学校）として、体系立てたカリキュラムで執事を育成し、所定の課程を修了した方へ協会認定資格を授与しています。
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== I. 日本執事アカデミーとは — リード3段落＋画像 ===== */}
      <NavyBand no="I" ja="日本執事アカデミーとは" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
                明確な基準で評価される、<span className="text-[#a38e65]">専門職としての執事へ</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                日本執事アカデミーは、一般社団法人全日本執事協会が運営する執事の教育・養成機関です。国内における執事学校・執事養成学校の役割を担い、執事の育成・認定を通じて、執事という職業の社会的価値を高めるという協会の理念が、アカデミーの育成方針の土台になっています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                エッセンシャルからマスターまで体系立てたカリキュラムで執事を育成し、所定の課程を修了し実技試験に合格した方へ、協会認定のバトラー資格を授与しています。育成した人材の質を保証することで、執事の作法をより広い現場で活かせるものへとつなげています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
                執事という仕事を、限られた世界だけの特別な職業としてではなく、明確な基準のもとで評価される専門職として社会に位置づけていくこと――それが、当協会が育成・認定を一貫して担う理由です。
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-still-china-01.webp" alt="金彩の洋食器。テーブル作法教育の教材イメージ" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== II. アカデミーが担う4つの役割 — 白カード（各役割に画像）===== */}
      <NavyBand no="II" ja="アカデミーが担う4つの役割" en="Our Role" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.no} className="flex flex-col sm:flex-row border border-[#e2ddd2] overflow-hidden group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative sm:w-[42%] shrink-0 h-48 sm:h-auto min-h-[190px]">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-3 left-3 font-['Playfair_Display',serif] text-[#f8f6f0] text-2xl drop-shadow-lg">{p.no}</span>
                </div>
                <div className="p-6 sm:p-7 flex flex-col justify-center text-left">
                  <h4 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== III. 協会とのつながり — 紺パネル＋画像 ===== */}
      <NavyBand no="III" ja="協会とのつながり" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-p-027-rel-academy-w2.webp" alt="アカデミーで育成された執事が現場で力を発揮する様子" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.02em] mb-6">
                教育部門として、<span className="text-[#d7b779]">協会の理念を担う</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] mb-4">
                日本執事アカデミーは、一般社団法人全日本執事協会が運営する教育部門です。執事の育成・認定を通じて職業の社会的価値を高めるという協会の理念が、アカデミーの育成方針の土台になっています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95]">
                アカデミーが育成した執事は、当協会が運営する執事サービス THE BUTLER などの現場で力を発揮しています。学びと実務が同じ協会のもとでつながっていることが、日本執事アカデミーの教育の特色です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== IV. 公式サイトのご案内 — 外部CTA ===== */}
      <NavyBand no="IV" ja="公式サイトのご案内" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">日本執事アカデミー 公式サイト</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.95] max-w-2xl mx-auto mb-8">
              コースや協会認定資格、学びの詳細については、日本の執事学校としての取り組みを紹介する公式サイトをご覧ください。
            </p>
            <a href="https://butler-academy.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              日本の執事学校・日本執事アカデミー 公式サイトを見る <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* ===== V. よくあるご質問（自前描画）===== */}
      <NavyBand no="V" ja="よくあるご質問" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.95] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ほかの関連サイト＋CTA ===== */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">ほかの関連サイト</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">執事の学びや資格に関心をお持ちの方へ</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/qualifications" className={BTN08_ON_NAVY}>執事資格制度を見る</Link>
              <Link to="/contact" className={BTN08_ON_NAVY}>お問い合わせ</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
